<script setup lang="ts">
// biome-ignore lint/style/useImportType: the template renders <OverlayPanel>, so the runtime binding is required
import OverlayPanel from "primevue/overlaypanel";
import { computed, ref } from "vue";
import JSONtoHTML from "@/components/forms/SharedComponents/WYSIWYG/JSONtoHTML.vue";
import type { WysiwygContent } from "@/components/program-manager/sessions/components/TodosSection/types";
import descIcon from "@/images/icon-description-api-navy-blue.svg";
import { hasTiptapText } from "@/util/tiptap";

type Props = {
  instructions: WysiwygContent;
};

const props = withDefaults(defineProps<Props>(), {
  instructions: undefined,
});

const hasInstructions = computed<boolean>(() => hasTiptapText(props.instructions));

const instructionsContent = computed<Record<string, unknown>>(() => props.instructions ?? {});

const op = ref<InstanceType<typeof OverlayPanel> | undefined>(undefined);

const onMouseOver = (event: MouseEvent): void => {
  if (hasInstructions.value) {
    op.value?.show(event);
  }
};

const onMouseLeave = (): void => {
  op.value?.hide();
};
</script>

<template>
  <span class="flex justify-center">
    <span
      :class="hasInstructions ? 'cursor-pointer' : 'opacity-40'"
      data-testid="instructions-icon"
      @mouseover.stop="onMouseOver"
      @mouseleave.stop="onMouseLeave"
    >
      <img :src="descIcon" alt="instructions icon" />
    </span>
    <OverlayPanel
      v-if="hasInstructions"
      ref="op"
      :pt="{ content: { class: 'p-3 bg-white max-w-xs text-sm text-indigo-base' } }"
    >
      <JSONtoHTML :tiptap-json="instructionsContent" data-testid="instructions-popover-content" />
    </OverlayPanel>
  </span>
</template>
